import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {

  constructor(private http: HttpClient) { }

  getUserUUID(username: string, password: string): Observable<any> {
    let url = environment.backEndUrl + '/profiles';

    let params = new HttpParams();
    params = params.append('username', username);
    params = params.append('birth_date', password);

    return this.http.get(url, { params: params });
  }

  getAssociatedProfiles(uuid_event_occurrence: string, uuid_passenger?: string): Observable<any> {
    let url = environment.backEndUrl + '/profiles/profile/booking-number';

    let params = new HttpParams();
    params = params.append('uuid_event_occurrence', uuid_event_occurrence);
    if (uuid_passenger) {
      params = params.append('uuid_passenger', uuid_passenger);
    }
    return this.http.get(url, { params: params });
  }
}
